export function Action(type, payload, error, meta) {
    return {
        type, payload, error, meta
    }
}